export default "__VITE_ASSET__MEIDtv1b__";